import { render, staticRenderFns } from "./Persona_historial_laboral.vue?vue&type=template&id=3c13b094"
import script from "./Persona_historial_laboral.vue?vue&type=script&lang=js"
export * from "./Persona_historial_laboral.vue?vue&type=script&lang=js"
import style0 from "./Persona_historial_laboral.vue?vue&type=style&index=0&id=3c13b094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports